module.exports = __webpack_public_path__ + "media/images/icon_level_blue-e16fa548ce6600de6c1249ca07633f83.png";